import { useEffect, useState } from 'react';
import { selectTabToggleValue } from 'store/Global/selectors';
import { useSelector, useDispatch } from 'react-redux';
import { toggleExpandCollapse } from 'store/Global/actions';
import { isEmpty } from 'lodash';

const useExpandable = (tab, fieldName, fieldValue, dataId) => {
  const dispatch = useDispatch();
  const isExpandedBase = useSelector((state) => selectTabToggleValue(state, tab, fieldName));
  const [isExpanded, setIsExpanded] = useState(isExpandedBase);
  const fieldHasValue = !isEmpty(fieldValue) || !!fieldValue;

  useEffect(() => {
    setIsExpanded(isExpandedBase);
  }, [isExpandedBase]);

  useEffect(() => {
    setIsExpanded(fieldHasValue);
    if (fieldHasValue !== isExpandedBase) {
      dispatch(toggleExpandCollapse(tab, {
        [fieldName]: {
          expanded: fieldHasValue
        }
      }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataId]);

  return isExpanded;
};

export default useExpandable;
